import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { IdayProfileComponent } from './iday-profile/iday-profile.component';
import { AuthGuard } from './services/auth.guard';
import { LogoComponent } from './logo/logo.component';

const routes: Routes = [
  {
    component: LoginpageComponent,
    path: '',
  },
  {
    component: LogoComponent,
    path: 'logo',
  },
  {
    component: IdayProfileComponent,
    path: 'iday-profile',
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
